<template>
    <section id="StudentCourses" class="schedule card">
        
        <div v-if="coursesAreLoaded == 1">
            <h2 id="schedule-header" class="card-header">
                <a id="coursesanchor" name="coursesanchor"></a>
                <button class="btn btn-link" data-toggle="collapse" aria-label="Toggle Schedule Section (Mobile View)" @click="collapsePanel" data-target=".schedule-card-body" aria-expanded="true" aria-controls="schedule-card-body"><span class="icon icon-doc-text-inv"></span>{{currentTerm.key}} Schedule</button>
            </h2>
            <div id="coursesContent" class="schedule-card-body card-body collapse" aria-labelledby="schedule-header">
                <div class="block block-top">
                    <div class="form-group">
                        <label for="TermCode">Change term:</label>
                        <select id="TermCode" class="courses_term_code form-control" v-model="termCode">
                            <option v-for="item in termList" :value="item.value" :key="item.value">
                                {{item.key}}
                            </option>
                        </select>
                    </div>
                </div>
                <div v-if="!notNullOrEmpty(courses)">
                    <p>You are not registered for courses this term.</p>
                </div>
                <div v-else>
                    <div v-for="(course, index) in courses" :key="index">
                        <div class="course block">
                            <h3>
                                <span v-if="!notNullOrEmpty(course.links)">
                                    {{course.courseTitle}}
                                </span>
                                <span v-else-if="course.links.length == 1">
                                    <a :href="course.links[0]" target="_blank">{{course.courseTitle}}</a>
                                </span>
                                <span v-else>
                                    <a href="#" class="multiCourseLinks" v-on:click="showMultiLinkCourse(course.links)">{{course.courseTitle}}</a>
                                </span>
                            </h3>
                            <p>{{course.subjectCode}} {{course.courseNumber}} {{course.sequenceNumber}} ({{course.courseReferenceNumber}}) {{course.partOfTerm}}
                                <span v-if="course.bannerCourse.courseRegistrationStatus.code == 'AU'">[Auditing]</span>
                            </p>
                            <p>Instructor: <a :href="'mailto:' + course.instructorEmail">{{course.primaryInstructor}}</a></p>
                            <div v-if="notNullOrEmpty(course.schedule)">
                                <div v-for="(sch, index) in course.schedule" :key="index">
                                    <p>
                                        {{sch.building}}
                                        {{sch.room}}
                                        {{sch.meetingDays}}
                                        {{sch.meetingTime}}
                                    </p>
                                </div>
                            </div>
                            <div v-if="!notNullOrEmpty(course.finalExamSchedule)">
                                <p class="finals small"><strong>Final Exam: </strong>No Final Exam Information Available. Contact instructor for details.</p>
                            </div>
                            <div v-else>
                                <p class="finals small"><strong>Final Exam: </strong>
                                    <span v-for="(item, index) in course.finalExamSchedule" :key="index">
                                        {{item.location}} {{item.day}} {{item.date}} {{item.startTime}} - {{item.endTime}} ({{item.examType}})
                                        <br v-if="index < course.finalExamSchedule.length - 1"/>
                                    </span>
                                    
                                </p>
                            </div>

                        </div>
                    </div>
                    <p>You can go to the <a href="https://courses.illinois.edu/" target="_blank">Course Explorer</a> for more information on your schedule and final exams.</p>
                    <p>For deadline or refund information, refer to <a href="http://www.registrar.illinois.edu/refunds" target="_blank">Refund information</a>, if dropping some classes, or <a href="http://www.registrar.illinois.edu/withdrawal" target="_blank">Withdrawal information</a>, if dropping ALL classes.</p>
            
                </div>
                <p><a :href="selfServiceXEPath" target="_blank">Register For Classes</a></p>
            </div>
            <b-modal id="multiLinkDialog" title="Course Links" v-model="multiLinkShow" ok-only @hide="multiLinkShow = !multiLinkShow">  
                <div v-for="(crse, index) in multiLinkCourseList" :key="index">
                    <a :href="crse" target="_blank">Course Link #{{index + 1}}</a>
                </div>
            </b-modal>
        </div>
        <div v-else>
            <h2 id="schedule-header" class="card-header">
                <a id="coursesanchor" name="coursesanchor"></a>
                <button class="btn btn-link" data-toggle="collapse" data-target=".schedule-card-body" aria-label="Toggle Schedule Section (Mobile View)" aria-expanded="true" aria-controls="schedule-card-body" @click="collapsePanel"><span class="icon icon-doc-text-inv"></span>Loading Schedule...</button>
            </h2>
             <div id="coursesContent" class="schedule-card-body card-body collapse" aria-labelledby="schedule-header">
                <div v-if="coursesAreLoaded == 2">
                        <p>We are having trouble loading this section. This could be because we can't find a record for you or we are having connectivity problems.</p>
                </div>
                <div v-else>
                    <spinner></spinner>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { isNullOrUndefined } from 'util';
    import spinner from "../components/spinner.vue";
    import { getSelfServiceXeUrl } from "@/common/envMixins";

    export default {
        name: "StudentCourses",
        components: {spinner},
        data() {
            return {
                multiLinkCourseList: [],
                multiLinkShow: false
            }
        },
        computed: {
            coursesAreLoaded() { return this.$store.state.coursesAreLoaded },
            termList() { return this.$store.state.studentCourses.termList },
            termCode: {
                get() {
                    return this.$store.state.studentCourses.defaultTermCode
                },
                set(value) {
                    const studentCrs = this.$store.state.studentCourses;
                    studentCrs.defaultTermCode = value;
                    this.$store.commit("setCourses", studentCrs);
                    this.$store.dispatch("getCourses");
                }
            },
            currentTerm() {
                return this.termList.filter(x => x.value == this.termCode)[0]   
            },
            courses() {
                const returnObj = this.$store.state.studentCourses.courses;
                if (!isNullOrUndefined(returnObj) && !isNullOrUndefined(returnObj.finalExamSchedule)) {
                    returnObj.finalExamSchedule.sort((a, b) => a.examType > b.examType ? 1 : -1);
                }
                if (!isNullOrUndefined(returnObj)) {
                    return returnObj.filter(x => x.bannerCourse.term == this.termCode);
                } else {
                    return null;
                }
            },
            selfServiceXEPath() { return getSelfServiceXeUrl()}
        },
        mounted() {
            if (this.$store.state.coursesAreLoaded == 0) {
                this.$store.dispatch("getCourses")
            }
        },
        methods: {
            showMultiLinkCourse(crseLinks) {
                this.multiLinkCourseList = crseLinks;
                this.multiLinkShow = true
                return false;
            }
        }
    }
</script>

